import AuthAPI from './authInstance'

const getAll = async (data) => {
  const response = await AuthAPI.get(`/admin/pickup-charge/list`)
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/pickup-charge/show/${data}`)
  return response.data
}

const createPickupCharge = async (data) => {
  const response = await AuthAPI.post(`/admin/pickup-charge/create`, data)
  return response.data
}

const editPickupCharge = async (data) => {
  const response = await AuthAPI.post(`/admin/pickup-charge/update`, data)
  return response.data
}

const deleteOne = async (data) => {
  const response = await AuthAPI.delete(`/admin/pickup-charge/delete/${data}`)
  return response.data
}

export const PickupChargeService = {
  getAll,
  getOne,
  createPickupCharge,
  editPickupCharge,
  deleteOne,
}
